import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import { useScrollPosition } from '../../hooks/useScrollPosition';

export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  const { scrollY } = useScrollPosition();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, key]);

  const showButton = scrollY > 400;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 bg-night-950 text-volt-500 rounded-full
        flex items-center justify-center hover:bg-volt-500 hover:text-night-950 transition-all duration-300
        ${showButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
      aria-label="Scroll to top"
    >
      <ArrowUp size={16} />
    </button>
  );
}
